export const SET_COUNTRIES = 'countries/set-countries';
export const UNSET_COUNTRIES = 'countries/unset-countries';
export const SET_ZIP_CODE_LIST = 'countries/zip-code-list';
export const SET_STATE_DATA = 'countries/state-data';
export const SET_ADDRESS_DATA = 'countries/address-data';
export const SET_ADDRESS_BOOK_DATA = 'countries/address-book-data';
export const SET_MORE_ADDRESS_BOOK_DATA = 'countries/more-address-book-data';
export const SET_ADDRESS_BOOK_DETAILS_DATA = 'countries/address-book-details-data';
export const SET_ADRESS_BOOK_OBJECT = 'countries/address-book-object';
